import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { authClient } from '../lib/auth-client';
import { posthog } from '../lib/posthog';

export function usePostHogPageviews() {
  const location = useLocation();
  useEffect(() => {
    if (!posthog.__loaded) return;
    posthog.capture('$pageview', {
      $current_url: window.location.href,
      pathname: location.pathname,
    });
  }, [location.pathname]);
}

export function usePostHogIdentify() {
  const { data: session } = authClient.useSession();
  const lastIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (!posthog.__loaded) return;
    const userId = session?.user?.id ?? null;

    if (userId && userId !== lastIdRef.current) {
      posthog.identify(userId, {
        email: session!.user.email,
        name: session!.user.name,
      });
      lastIdRef.current = userId;
    } else if (!userId && lastIdRef.current) {
      posthog.reset();
      lastIdRef.current = null;
    }
  }, [session?.user?.id, session?.user?.email, session?.user?.name]);
}
